<template>
  <loading :loading="isLoading" message="Adding contact">
    <h4><i class="fas fa-user"></i> New contact</h4>
    <error :notdismissable="true" :error="error"/>
    <b-form-group id="newContactName"
          label="Name:"
          label-for="name">
          <b-form-input id="name"
            type="text"
            v-model="newContact.name"
            required
            placeholder="Bob Jones"/>
    </b-form-group>
    <b-form-group id="newContactType"
          label="Contact type:"
          label-for="type">
          <b-form-select id="type"
            v-model="newContact.type"
            required
            :options="contactTypes"/>
    </b-form-group>
    <b-form-group id="newContactTelephone"
          label="Telephone number:"
          label-for="tel">
          <b-form-input id="tel"
            type="tel"
            v-model="newContact.telephone"
            required
            placeholder="01234567890"/>
    </b-form-group>
    <b-form-group id="newContactEmailAddress"
          label="Email address:"
          label-for="email">
          <b-form-input id="email"
            type="email"
            v-model="newContact.emailAddress"
            required
            placeholder="first.last@council.gov.uk"/>
    </b-form-group>
    <b-button @click="addContact">Add contact</b-button>
  </loading>
</template>

<script>
import { mapGetters } from 'vuex'
import Error from './Error.vue'
import Loading from './Loading.vue'

export default {
  components: { Error, Loading },
  data() {
    return {
      isLoading: false,
      error: null,
      newContact: {
        type: 'external',
        emailAddress: null,
        telephone: null,
        name: null,
      },
      contactTypes: [
        { value: 'external', text: 'External / Primary contact' },
        { value: 'benefits_discounts', text: 'CT discounts' },
        { value: 'benefits_shbe', text: 'SHBE' },
        { value: 'business_rates', text: 'Business rates' },
        { value: 'electoral_role', text: 'Electoral roll' },
        { value: 'housing_register', text: 'Housing register' },
        { value: 'planning', text: 'Planning applications' },
        { value: 'taxi_drivers', text: 'Taxi drivers' },
        { value: 'other', text: 'Other' },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'oidcUser',
    ]),
    authority() {
      return this.$authority(this.oidcUser);
    },
  },
  methods: {
    validate() {
      this.error = null;
      if ((this.newContact.name || '').length < 5) {
        this.error = 'Full-name is required';
        return false;
      }
      if ((this.newContact.telephone || '').length < 8) {
        this.error = 'Telephone is required';
        return false;
      }
      if ((this.newContact.emailAddress || '').indexOf('@') === -1) {
        this.error = 'Email address is required';
        return false;
      }
      return true;
    },
    addContact() {
      if (!this.validate()) {
        return;
      }
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.runAction('panessex', access_token, {
        actionName: 'NewContact',
        parameters: {
          ...this.newContact,
        },
      })
      .then(() => {
        this.newContact = {};
        this.$store.dispatch('invalidateCache', `contacts_for_${this.authority}`);
        this.$emit('created');
      })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },
  },
};
</script>
